import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/components/Layouts/Default';
import { Auth } from 'aws-amplify';
import { EventBus } from '@/utils/eventbus';

@Component
export default class Home extends Vue {

  private created() {
    this.$store.dispatch('CLEAR_CART')
    this.$store.dispatch('CLEAR_PLAYER')
    Auth.signOut().then(() => {
      setTimeout(() => {
        EventBus.$emit('qpLogout')
      }, 1500)
    })
  }

  private render(h: any) {
    return (
      <DefaultLayout>
        <div slot='navigation'>
          <h1 class='navigation-title'>Logging out</h1>
        </div>
        <div class='lds-grid'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </DefaultLayout>
    );
  }
}
